import { Moment } from "moment-timezone";
import { parseDateWithTimezone } from "./functions";
import { TimezoneObject } from "types/common";

export const convertToTimezone = (
    date: Moment,
    timezone: string,
    timeZoneObject: TimezoneObject
): Moment => {
    const tzInfo = timeZoneObject[timezone];
    if (!tzInfo) {
        // If timezone info not found, just convert using moment's tz
        return date.clone().tz(timezone);
    }
    return parseDateWithTimezone(date, tzInfo).tz(timezone);
};

export const getInputMask = (is12HourFormat: boolean): string => {
    return is12HourFormat ? "____/__/__ __:__ _M" : "____/__/__ __:__";
};
